<template>
  <div  class="wrapper">
    <a v-for="(item, index) in socials" :key="index" :href="item.link" target="_blank" rel="noreferrer">
      <img
        class="icon"
        :src="item.icon"
        alt="social media icon"
      />
    </a>
    <p v-if="!socials.length">No social network provided at the moment</p>
  </div>
</template>

<script>
export default {
  props: ["socials"],
 
}
</script>

<style>
.wrapper {
    display: flex;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
}

.icon {
    width: 25px;
    height: 25px;
    margin: 0 5px;
}

.wrapper a {
    position: relative;
    overflow: hidden;
    padding-bottom: 4px;
}

.wrapper a::before {
    content: "";
    position: absolute;
    border-bottom: 2px solid var(--green);
    bottom: 0;
    left: -100%;
    z-index: 10;
    width: 100%;
    transition: left 0.3s;
}

.wrapper a:hover::before {
    left: 0;
}
.wrapper>p{
    color: #888;
}
</style>